<div *ngIf="isVisible" class="not-shared-data" [tp]="translations.noSharedDataTp"></div>
